export default __webpack_public_path__ + "static/media/eb-ultra-wht-1.d882620e.png";